import { enUS as dateFnsLocaleEn } from "date-fns/locale";
import { en as core } from "@wx/core-locales";
export const en = {
    ...core,
    dateFnsLocale: dateFnsLocaleEn,
    scheduler: {
        "New Event": "New Event",
        "Add description": "Add description",
        "Create event": "Create event",
        "Edit event": "Edit event",
        "Delete event": "Delete event",
        "Event name": "Event name",
        "Start date": "Start date",
        "End date": "End date",
        "All day": "All day",
        "No events": "No events",
        Type: "Type",
        Description: "Description",
        Today: "Today",
        Day: "Day",
        Week: "Week",
        Month: "Month",
        Timeline: "Timeline",
        Calendars: "Calendars",
        hourFormat: "H",
        minuteFormat: "mm",
        meridianFormat: " a",
        monthFormat: "EEE",
        dateFormat: "EEE, d",
        agendaDateFormat: "MMMM d EEEE",
        unassignFormat: "d MMM yyyy",
        Color: "Color",
        Delete: "Delete",
        Edit: "Edit",
        Calendar: "Calendar",
        New: "New",
        Name: "Name",
        Save: "Save",
        Add: "Add",
        Event: "Event",
        confirmDelete: "Are you sure you want to delete {item}?",
        confirmUnsaved: "You have unsaved changes!  Do you want to discard them?",
        "Repeat event": "Repeat event",
        viewAll: "+{count} more",
        Never: "Never",
        Every: "Every",
        Workdays: "On work days",
        Year: "Year",
        Custom: "Custom",
        Ends: "Ends",
        After: "After",
        "On date": "On date",
        events: "events",
        "recurring event": "recurring event",
        all: "All events",
        future: "This and following events",
        only: "This event",
        recurringActionError: "Start date cannot be after recurrent expiry date",
        Assignees: "Assignees",
        "Recurring events": "Recurring events",
        "Single events": "Single events",
        recurringEveryMonthDay: "Every {date}",
        recurringEveryMonthPos: "Every {pos} {weekDay}",
        recurringEveryYearDay: "Every {date} of {month}",
        recurringEveryYearPos: "Every {pos} {weekDay} of {month}",
    },
};
//# sourceMappingURL=en.js.map